// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editable-input {
  padding: 4px 8px;
  margin: 0 4px;
  width: auto;
}

.save-button-container {
  text-align: right;
  margin-top: 20px;
}

.save-button {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #1976d2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.save-button:hover {
  background-color: #115293;
}
/* Container for each label-input pair */
.section p {
  display: flex;
  align-items: center;
  margin: 6px 0;
}

/* Style the labels (e.g., "Name:", "TFN:") */
.section p strong {
  width: 200px; /* Adjust based on label lengths */
  text-align: left;
  display: inline-block;
  font-weight: 600;
}

/* Style the editable inputs */
.editable-input {
  flex: 1 1;
  padding: 6px 8px;
  margin-left: 8px;
  min-width: 200px;
  max-width: 300px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

/* Table alignment fix */
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

th, td {
  text-align: left;
  padding: 8px;
  border-bottom: 1px solid #ddd;
}

th {
  background-color: #f5f5f5;
}

/* Ensure all table cells align their contents in the middle */
td {
  vertical-align: middle;
}

/* Align input fields to the text baseline */
td input.editable-input {
  vertical-align: middle; /* or try 'baseline' if needed */
  margin-left: 4px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.company-info {
  flex: 1 1;
  text-align: left;
  max-width: 50%;
}

.payslip-header {
  text-align: right;
  min-width: 200px;
}

/* Optional: style label alignment in company info */
.company-info p {
  display: flex;
  align-items: center;
  margin: 4px 0;
}

.company-info p strong {
  width: 80px;
  display: inline-block;
}

`, "",{"version":3,"sources":["webpack://./src/payslip/PayrunDetailPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA,6CAA6C;AAC7C;EACE,YAAY,EAAE,kCAAkC;EAChD,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8DAA8D;AAC9D;EACE,sBAAsB;AACxB;;AAEA,4CAA4C;AAC5C;EACE,sBAAsB,EAAE,gCAAgC;EACxD,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB","sourcesContent":[".editable-input {\n  padding: 4px 8px;\n  margin: 0 4px;\n  width: auto;\n}\n\n.save-button-container {\n  text-align: right;\n  margin-top: 20px;\n}\n\n.save-button {\n  padding: 10px 20px;\n  font-size: 16px;\n  background-color: #1976d2;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.save-button:hover {\n  background-color: #115293;\n}\n/* Container for each label-input pair */\n.section p {\n  display: flex;\n  align-items: center;\n  margin: 6px 0;\n}\n\n/* Style the labels (e.g., \"Name:\", \"TFN:\") */\n.section p strong {\n  width: 200px; /* Adjust based on label lengths */\n  text-align: left;\n  display: inline-block;\n  font-weight: 600;\n}\n\n/* Style the editable inputs */\n.editable-input {\n  flex: 1;\n  padding: 6px 8px;\n  margin-left: 8px;\n  min-width: 200px;\n  max-width: 300px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n/* Table alignment fix */\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n}\n\nth, td {\n  text-align: left;\n  padding: 8px;\n  border-bottom: 1px solid #ddd;\n}\n\nth {\n  background-color: #f5f5f5;\n}\n\n/* Ensure all table cells align their contents in the middle */\ntd {\n  vertical-align: middle;\n}\n\n/* Align input fields to the text baseline */\ntd input.editable-input {\n  vertical-align: middle; /* or try 'baseline' if needed */\n  margin-left: 4px;\n}\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 20px;\n}\n\n.company-info {\n  flex: 1;\n  text-align: left;\n  max-width: 50%;\n}\n\n.payslip-header {\n  text-align: right;\n  min-width: 200px;\n}\n\n/* Optional: style label alignment in company info */\n.company-info p {\n  display: flex;\n  align-items: center;\n  margin: 4px 0;\n}\n\n.company-info p strong {\n  width: 80px;\n  display: inline-block;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
